var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userData)?_c('b-card',{staticClass:"card-congratulation-medal"},[_c('h5',[_vm._v("Bienvenido 👋 "+_vm._s(_vm.userData.fullName)+"!")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }